<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
    <div class="flex justify-between header-table" #pageOptionBtnGroup>
        <div class="title-page"><span class="title">Báo cáo thông tin cơ sơ giáo dục</span>
            <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
        </div>
        <div class="btn-option flex">
            <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
                <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
                    nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
                    <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
                </button>
            </ng-container>
            <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
                <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
                    Xuất excel
                </button>
            </ng-container>
            <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
                <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
                    <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
                    Xuất excel
                </button>
            </ng-container>
        </div>
    </div>
    <form nz-form class="ant-advanced-search-form" #pageSearch>
        <div nz-row [nzGutter]="24">

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24" nzRequired>Năm</nz-form-label>
                    <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}"
                        nzPlaceHolder="Nhập năm" (nzOnOpenChange)="changeYear()"></nz-date-picker>
                </nz-form-item>
            </div>

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24">Cấp trực thuộc</nz-form-label>
                    <asc-autocomplete [ascModel]="DirectlyUnderControl"
                        (ascModelChange)="changeDirectlyUnderACFn($event)" placeholder="Chọn cấp trực thuộc..."
                        [getListAC]="getDirectlyUnderACFn">
                    </asc-autocomplete>
                </nz-form-item>
            </div>

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24">Phương thức giáo dục</nz-form-label>
                    <asc-autocomplete [ascModel]="ModesOfEducationControl"
                        (ascModelChange)="changeModesOfEducationACFn($event)" placeholder="Chọn phương thức giáo dục..."
                        [getListAC]="getModesOfEducationACFn">
                    </asc-autocomplete>
                </nz-form-item>
            </div>

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24">Phân hệ</nz-form-label>
                    <asc-autocomplete [ascModel]="ModuleControl" (ascModelChange)="changeModule($event)"
                        placeholder="Chọn phân hệ..." [getListAC]="getModuleACFn">
                    </asc-autocomplete>
                </nz-form-item>
            </div>

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24">Loại hình cơ sở giáo dục</nz-form-label>
                    <asc-autocomplete [ascModel]="TypeOfEducationControl"
                        (ascModelChange)="changeTypeOfEducation($event)" placeholder="Chọn loại hình cơ sở giáo dục..."
                        [getListAC]="getTypeOfEducationACFn">
                    </asc-autocomplete>
                </nz-form-item>
            </div>

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24">Hình thức giáo dục</nz-form-label>
                    <asc-autocomplete [ascModel]="StudyModeControl" (ascModelChange)="changeStudyMode($event)"
                        placeholder="Chọn hình thức giáo dục..." [getListAC]="getStudyModeACFn">
                    </asc-autocomplete>
                </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label #label nzSpan="24" nzFor="IsDisability">Học sinh khuyết tật tại cơ sở giáo dục</nz-form-label>
                    <nz-form-control nzSpan="24">
                        <nz-radio-group [(ngModel)]="commonFilter.IsDisability" [ngModelOptions]="{standalone: true}">
                             <label nz-radio [nzValue]="-5">Tất cả</label>
                             <label nz-radio [nzValue]="1">Có</label>
                             <label nz-radio [nzValue]="0">Không</label>
                        </nz-radio-group>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col *ngIf="isCollapse" nzSpan="24">
                <div style="visibility: hidden; margin-top: 5px">i</div>
            </div>
        </div>
        <div nz-row>
            <div nz-col [nzSpan]="24" class="search-area">
                <button nz-button class="flex items-center justify-center"
                    [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" nz-tooltip (click)="toggleCollapse()"><i nz-icon
                        nzType="filter" nzTheme="outline"></i></button>
                <button nz-button class="flex items-center justify-center" (click)="clear()"
                    nzTooltipTitle="Xóa tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear"
                        nzTheme="outline"></i></button>
                <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
                    <button nz-button class="flex items-center justify-center" [nzType]="'primary'"
                        (click)="reload()">Tìm
                        kiếm</button>
                </ng-container>
                <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
                    <button nz-button class="flex items-center justify-center" style="width: 100px;"
                        [nzType]="'primary'" nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip
                        (click)="reload()"><i nz-icon nzType="search" nzTheme="outline"></i></button>
                </ng-container>
                <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
                    <button nz-button class="flex items-center justify-center" [nzType]="'primary'"
                        (click)="reload()"><i nz-icon nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
                </ng-container>
            </div>
        </div>
    </form>
    <div class="relative">
        <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="dataTable"
            nzSize="small" [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full"
            [nzFrontPagination]="false" [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
            [nzPageSizeOptions]="pageSizeOptions" (nzPageIndexChange)="pageIndexEvent($event)"
            (nzPageSizeChange)="pageSizeEvent($event)">
            <thead>
                <tr #pageHeaderTable>
                    <th nzWidth="20px" rowspan="2" nzLeft>STT
                    </th>
                    <th rowspan="2" nzWidth="40px" nzLeft>Mã đơn vị</th>
                    <th rowspan="2" nzWidth="75px" nzLeft>Tên cơ sở</th>
                    <th rowspan="2" nzWidth="75px">Cấp trực thuộc</th>
                    <th rowspan="2" nzWidth="75px">Cấp học/trình độ đào tạo</th>
                    <th rowspan="2" nzWidth="75px">Phương thức giáo dục</th>
                    <th rowspan="2" nzWidth="75px">Phân hệ</th>
                    <th rowspan="2" nzWidth="75px">Loại hình cơ sở giáo dục</th>
                    <th rowspan="2" nzWidth="75px">Hình thức giáo dục</th>
                    <th rowspan="2" nzWidth="75px">Địa chỉ</th>
                    <th rowspan="2" nzWidth="75px">Tên lãnh đạo</th>
                    <th rowspan="2" nzWidth="75px">Điện thoại</th>
                    <th rowspan="2" nzWidth="75px">Email</th>
                </tr>

            </thead>
            <tbody>
                <tr *ngFor="let data of Table.data; let i = index">
                    <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
                    <td nzLeft>{{data.educationAndTrainingCode}}</td>
                    <td nzLeft>{{data.educationAndTrainingName}}</td>
                    <td>{{data.directlyUnderName}}</td>
                    <td>{{data.disSchoolSchoolLevels}}</td>
                    <td>{{data.modesOfEducationName}}</td>
                    <td>{{data.modulesName}}</td>
                    <td>{{data.typeOfSchoolName}}</td>
                    <td>{{data.studyModeName}}</td>
                    <td>{{data.address}}</td>
                    <td>{{data.director}}</td>
                    <td>{{data.directorPhoneNumber}}</td>
                    <td>{{data.directorEmail}}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
